export const MasterEnum = {
    SettingsDetail :{
        Module_App_Size_And_Position__Def_App_Width: 1,
        Module_App_Size_And_Position__Def_App_Height: 2,
        Default_Core_Effective_Logging__Core_Log_RT: 3,
        Default_Core_Effective_Logging__Core_Log_HR: 4,
        Default_Core_Effective_Logging__Core_Log_DT: 5,
        Module_App_Size_And_Position__Def_App_X: 6,
        Module_App_Size_And_Position__Def_App_Y: 7,
        Module_App_Size_And_Position__Def_App_Max_Flag: 9,
        Mail_Controls__Button_Save: 10,
        Mail_Controls__Button_Skip: 11,
        Mail_Controls__Combo_Batch: 14,
        Mail_Controls__Combo_Document_Group: 15,
        Mail_Controls__Combo_Document_Type: 16,
        Mail_Controls__Combo_Document_Source: 17,
        Mail_Controls__Text_Case: 20,
        NoteTemplate_UIElement_Mulitple__Delimiter_Nth: 21,
        NoteTemplate_UIElement_Mulitple__Delimiter_Last: 22,
        NoteTemplate_UIElement_Mulitple__Delimiter_Two_Case: 23,
        Mail_Controls__ComboCopyTo01: 24,
        Mail_Controls__ComboCopyTo02: 25,
        Mail_Controls__ComboCopyTo03: 26,
        UI_Miscellaneous__Family_Violence_Indicator_Text: 27,
        UI_Data_Validation__Case_Number_Max_Digits: 28,
        OnBase_Related__OnBase_URL: 29,
        OnBase_Related__OnBase_DB_Name: 30,
        Mail_Controls__Text_Worker_Name: 31,
        Mail_Controls__TextBlock_Family_Violence: 32,
        Mail_Controls__TextBlock_CaseWorker_UserName: 33,
        Module_App_Size_And_Position__Min_App_Width: 34,
        Module_App_Size_And_Position__Min_App_Height: 35,
        Mail_Controls__Text_First_Name: 37,
        Mail_Controls__Text_Last_Name: 38,
        UI_Data_Validation__First_Name_Min_Length: 39,
        UI_Data_Validation__Last_Name_Min_Length: 40,
        UI_Data_Validation__SSN_Length: 41,
        Mail_Controls__Text_SSN: 42,
        Mail_Report_Controls__WindowsFormsHost: 45,
        Mail_Controls__Text_Court_ID: 49,
        Mail_Controls__Grid_Content: 50,
        Mail_Controls__Index_Dock_Panel: 51,
        Mail_Controls__Grid_Viewer: 53,
        Mail_Controls__Grid_Report_Viewer: 54,
        Mail_Controls__Dock_Panel_Reports: 55,
        Mail_Controls__Dock_Panel_Research: 56,
        Mail_Controls__App_Name: 57,
        Mail_Controls__Stack_Standard_App_Menu: 58,
        Mail_Controls__Logo_Mail: 59,
        UI_Data_Validation__CourtID_Pattern: 60,
        Mainframe_Related__Mainframe_Not_Connected: 62,
        Mail_Controls__Combo_State_Name: 63,
        Reporting_Related__SSRS_URL_List: 64,
        Reporting_Related__Master_SQL_Server_Database_Schema: 65,
        Reporting_Related__Client_SQL_Server_Database_Schema: 66,
        Mail_Controls__Document_Viewer_Container_Element: 67,
        Mainframe_Related__Mainframe_Narrative_Maximum_Characters: 68,
        Mainframe_Related__Mainframe_Narrative_Characters_Per_Line: 69,
        Mail_Controls__Textblock_NCP_ID: 71,
        Mail_Controls__Textblock_CP_ID: 72,
        Reporting_Related__Logging_SQL_Server_Database_Schema: 73,
        Reporting_Related__Report_SQL_Server_Database_Schema: 74,
        Mail_Controls__Text_Narrative: 75,
        UI_Data_Validation__Name_Pattern: 77,
        Mainframe_Related__Mainframe_ShortSessionName: 78,
        Mainframe_Related__Mainframe_HLLAPI_DLLName: 79,
        OnBase_Related__OnBase_SQL_Server_Database_Schema_Name: 80,
        UI_Miscellaneous__Region_Indication_Name: 81,
        UI_Miscellaneous__Region_Indication_Title: 82,
        Workflow_Parameters__Workflow_Stale_Lock_Timeout_Min: 84,
        UI_Data_Validation__TracNote_Max_Char_Length: 85,
        Mail_Controls__Combo_County_Name: 86,
        Reporting_Related__Client_Template_SQL_Server_Database_Schema: 93,
        OnBase_Related__Skipped_Document_Doc_Source: 94,
        OnBase_Related__Keyword_Document_Source: 95,
        OnBase_Related__Scanned_Mail_DocType: 96,
        OnBase_Related__Supervisor_Required_DocType: 97,
        OnBase_Related__Keyword_NCP_SSN: 102,
        OnBase_Related__Keyword_CP_SSN: 103,
        OnBase_Related__Keyword_CP_First_Name: 104,
        OnBase_Related__Keyword_CP_Last_Name: 105,
        OnBase_Related__Keyword_NCP_First_Name: 106,
        OnBase_Related__Keyword_NCP_Last_Name: 107,
        OnBase_Related__Keyword_Case_Number: 108,
        UI_Miscellaneous__Weekend_Date_Range_Past_Offset: 109,
        UI_Miscellaneous__Weekend_Date_Range_Future_Offset: 110,
        MultiState_Support__Client_DAL_SPN: 111,
        Workflow_Parameters__Workflow_QA_ActivityTypeID: 112,
        Workflow_Parameters__QA_Review_Note: 121,
        Module_Executable_Path_Root__Module_Executable_Path_Abbreviated: 122,
        Install__Module_Install_Location: 123,
        OnBase_Related__OnBase_Doc_ListViewer_Overall_Enable: 125,
        UI_Miscellaneous__District_Field_Show_Enable: 126,
        UI_Miscellaneous__County_Field_Show_Enable: 127,
        UI_Data_Validation__Case_Number_Regex_Pattern: 129,
        UI_Miscellaneous__Use_DistrictCounty_Hierarchy: 130,
        Install__Core_Install_Location: 132,
        UI_Miscellaneous__Customer_ServiceContact_Tab_Ver_Splitter_Pos_Defa: 133,
        UI_Miscellaneous__Customer_ServiceContact_Tab_Ver_Splitter_Pos_Rela: 134,
        UI_Miscellaneous__Walk_InMain_Ver_Split_Pos_Default: 135,
        UI_Miscellaneous__Walk_InMain_Ver_Split_Pos_Related_Default: 136,
        UI_Data_Validation__Legal_Case_Number_Regex_Pattern: 140,
        UI_Data_Validation__Legal_Court_Number_Max_Length: 141,
        Alert_Import_Processing__SFTP_Executable: 142,
        Alert_Import_Processing__SFTP_Working_Directory: 143,
        Alert_Import_Processing__SFTP_Script_Name: 144,
        Alert_Import_Processing__Alert_Import_File: 145,
        Alert_Import_Processing__Email_List_For_Success: 146,
        Alert_Import_Processing__Email_List_For_Failure: 147,
        Alert_Import_Processing__Wait_Loop_Interval: 148,
        OnBase_Related__OnBase_Server_TimeZone: 150,
        Mainframe_Related__QA_Of_Case_Narrative: 151,
        UI_Miscellaneous__Workflow_Activity_Index: 164,
        Mail_Controls__ButtonSearch: 165,
        Mail_Controls__NoCaseCheckBox: 166,
        UI_Miscellaneous__Input_Channel_Field_Show_Enable: 167,
        UI_Miscellaneous__Case_Type_Field_Show_Enable: 168,
        UI_Miscellaneous__WalkIn_Queue_Auto_Refresh_Sec: 170,
        UI_Miscellaneous__Workflow_Activity_Index_WalkIn: 171,
        Workflow_Parameters__My_Pace_Inner_Boundary: 172,
        Workflow_Parameters__My_Pace_Outer_Boundary: 173,
        UI_Miscellaneous__Workflow_Activity_Index_Actions_Taken_Detail: 174,
        Automatic_Adjustment_Parameters__Data_Interval_For_Standard_Time_Adjustment: 175,
        Workflow_Parameters__Action_Taken_Detail_Default_Sub_Tab: 176,
        Workflow_Parameters__Default_Case_Sub_Tab: 177,
        YW_DMS_Related__YW_DMS_Repository_Base_Path: 180,
        UI_Miscellaneous__Contact_Center_Contact_Tab_Ver_Splitter_Pos_Defa: 181,
        UI_Miscellaneous__Contact_Center_Contact_Tab_Ver_Splitter_Pos_Rela: 182,
        UI_Miscellaneous__CatSubCatResult_Display_Order_Sort: 183,
        Reporting_Related__Document_Imaging_System: 184,
        UI_Miscellaneous__Caseworker_Fields_Show_Enable: 233,
        UI_Miscellaneous__Case_Status_Field_ShowHideDisable: 234,
        Alert_Import_Processing__MS_Alerts_U01_Source_Path: 235,
        Alert_Import_Processing__MS_Alerts_U01_Archive_Path: 236,
        UI_Miscellaneous__Workflow_Activity_Max_Actions: 238,
        Mainframe_Related__Build_Word_Wrapped_Text : 239,
        UI_Miscellaneous__Multipart_Narrative_Delimiter: 240,
        UI_Miscellaneous__Multipart_Narrative_Connector: 241,
        QA_Related__Warning_Limit_For_Bulk_QA_Submission: 242,
        QA_Related__Maximum_Limit_For_Bulk_QA_Submission: 243,
        DMS_Scanning__Document_Per_Batch: 244,
        UI_Miscellaneous__Show_CaseWorker_Flag: 245,
        DMS_Scanning__Blank_Page_Tolerance: 246,
        UI_Miscellaneous__Auto_Show_Contact_Center_Scripts: 247,
        UI_Miscellaneous__Auto_Show_Contact_Center_Scripts_Allow_Toggle: 248,
        UI_Miscellaneous__Workflow_Workflow_Add_Tab_Ver_Splitter_Pos_Defa: 249,
        UI_Miscellaneous__Workflow_Workflow_Add_Tab_Ver_Splitter_Pos_Rela: 250,
        UI_Miscellaneous__Workflow_Workflow_Work_Tab_Ver_Splitter_Pos_Defa: 251,
        UI_Miscellaneous__Workflow_Workflow_Work_Tab_Ver_Splitter_Pos_Rela: 252,
        UI_Miscellaneous__Document_Distribution_Document_Distribution_Ver_S: 253,
        UI_Miscellaneous__Workflow_Workflow_Report_Tab_Ver_Splitter_Pos_Def: 263,
        UI_Miscellaneous__Workflow_Workflow_Report_Tab_Ver_Splitter_Pos_Rel: 264,
        UI_Data_Validation__Name_Content_Length: 265,
        UI_Miscellaneous__Data_Interval_For_Next_Action_Standard_Time_Adjust: 266,
        Telephony_Service__Telephony_Server_List: 267,
        Telephony_Service__Telephony_Server_Port: 268,
        Telephony_Service__Telephony_Use_HTTPS: 269,
        Workflow_Parameters__Contact_Center_2_Workflow_Map: 270,
        UI_Miscellaneous__DocDistro_DocDistro_Scan_Tab_Ver_Splitter_Pos_Def: 271,
        UI_Miscellaneous__DocDistro_DocDistro_Scan_Tab_Ver_Splitter_Pos_Rel: 272,
        UI_Miscellaneous__DocDistro_DocDistro_Search_Ver_Splitter_Pos_Def: 273,
        UI_Miscellaneous__DocDistro_DocDistro_Search_Ver_Splitter_Pos_Rel: 274,
        Workflow_Parameters__Confidential_Case_Criteria: 275,
        Reporting_Related__Reporting_Parameters_Sort_By: 276,
        Telephony_Service__Switchover_Delay_Ms: 277,
        Telephony_Service__Switchover_Retry_Count: 278,
        Telephony_Service__Auto_Call_Reject_Status: 279,
        YW_DMS_Related__AutoEnd_Doc_WF_Wrong_Case_Detail_Id: 280,
        YW_DMS_Related__AutoEnd_Doc_WF_Wrong_Doc_Type_Detail_Id: 281,
        Reporting_Related__IVR_Import_SQL_Server_Database_Schema: 282,
        UI_Miscellaneous__Smtp_Server_Host_Name: 283,
        UI_Miscellaneous__Send_Mail_From_User_Email_Address: 284,
        UI_Miscellaneous__Contact_Center_Email_From_Address: 285,
        UI_Miscellaneous__Auto_Send_Contact_Center_Action_Emails: 286,
        UI_Miscellaneous__FirstName_Search_Minimum_Length: 287,
        UI_Miscellaneous__LastName_Search_Minimum_Length: 288,
        Telephony_Service__ACD_Queue_List_Of_Name_Starts_With: 292,
        SignalRService__SignalR_Service_URL: 293,
        UI_Miscellaneous__Contact_Center_Email_Reply_To_Address: 294,
        UI_Data_Validation__Contact_ID_Regex_Pattern: 295,
        UI_Data_Validation__Interaction_ID_Regex_Pattern: 296,
        Reporting_Related__Power_BI_Export_SQL_Server_Database_Schema: 297,
        OnBase_Related__ObViewer_Enable_All_Buttons: 298,
        Reporting_Related__Completed_Queue_Data_Export_Purge_Age_Days: 299,
        SignalRService__QA_Notification_Lifespan: 300,
        SignalRService__SignalR_Service_Enable: 301,
        LA_Manage_Website_Recipient_Email_Address__LA_Manage_Website_To_Email: 302,
        YW_DMS_Related__OCR_Page_Separator: 303,
        YW_DMS_Related__YW_Processed_Repository_Base_Path: 304,
        Workflow_Parameters__Doc_Distro_Start_Queue_Text: 305,
        Workflow_Parameters__Contact_Center_Start_Queue_Text_Actions_Taken: 306,
        Workflow_Parameters__WalkIn_Start_Queue_Text: 307,
        Workflow_Parameters__Import_Start_Queue_Text: 308,
        RestApiService__WY_Rest_API_URL: 309,
        Reporting_Related__Prem_Genesys_SQL_Server_Database_Schema: 310,
        Reporting_Related__VAMAR_YTrac_SQL_Server_Database_Schema: 311,
        Reporting_Related__VAMAR_QAiPOD_SQL_Server_Database_Schema: 312,
        Reporting_Related__SSRS_Path: 313,
        UI_Miscellaneous__Special_Circumstance_Indicator_Text_Without_FVI: 314,
        UI_Miscellaneous__Special_Circumstance_Indicator_Text_With_FVI: 315,
        Reporting_Related__Report_Execution_Timeout: 316,
        Scheduler__Sweep_Sleep_Time: 317,
        Scheduler__Sweep_Loop_Attempts: 318,
        SignalRService__SignalR_Service_Retries: 319,
        SignalRService__SignalR_Service_Delay: 320,
        Timeouts__QueueCompleted_SQL_Timeout: 321,
        Timeouts__QueueCompleted_Web_Timeout: 322,
        DMS_Scanning__Enable_Disconnected_Scanning_Mode: 323,
        DMS_Scanning__Disconnected_Scanning_Path: 324,
        DMS_Scanning__Document_Separator_X_Value: 325,
        DMS_Scanning__Document_Separator_Y_Value: 326,
        DMS_Scanning__Document_Separator_Width_Value: 327,
        DMS_Scanning__Document_Separator_Height_Value: 328,
        DMS_Scanning__Document_Separator_Display_LoginName: 329,
        Reporting_Related__Cloud_Phone_System_SQL_Server_Database_Schema: 330,
        Timeouts__Import_Load_Timeouts: 331,
        Timeouts__BatchDocument_Stale_Lock_Timeout_Min: 332,
        Module_Executable_Path_Root__Enable_Version_Check: 333,
        Alert_Import_Processing__Vendor_Identifier: 334,
        Alert_Import_Processing__Alert_Import_Cutoff_Date: 335,
        Alert_Import_Processing__Alert_Import_Format_File: 336,
        UI_Miscellaneous__Workflow_Start_Tab: 337,
        Alert_Import_Processing__Alert_Import_Archive_Path: 338,
        Alert_Import_Processing__Alert_Import_Source_File: 339,
        Alert_Import_Processing__Alert_Import_FTP_Profile: 340,
        Alert_Import_Processing__Alert_Import_Email_Subject: 341,
        Alert_Import_Processing__Default_Email_Profile: 342,
        DMS_Scanning__Local_Sweep_Path_Prefix: 343,
        DMS_Scanning__Copy_Link_Temp_Path: 344,
        DMS_Scanning__Copy_Link_Purge_Age: 345,
        Alert_Import_Processing__Staging_Clone_Email_List_For_Success: 346,
        Alert_Import_Processing__Staging_Clone_Email_List_For_Failure: 347,
        Alert_Import_Processing__Staging_Clone_Email_Subject: 348,
        UI_Data_Validation__Batch_Number_Regex_Pattern: 349,
        Automatic_Adjustment_Parameters__Standard_Time_Recalc_Success_Email_List: 350,
        Automatic_Adjustment_Parameters__Standard_Time_Recalc_Failure_Email_List: 351,
        DMS_Scanning__Copy_Link_Enable: 352,
        Custom_Report_Sproc_Parameters__MO_Referred_To_Output_Action_ID_List: 353,
        Custom_Report_Sproc_Parameters__MO_Transfer_File_To_FSD_Step_ID_List: 354,
        QA_Related__QA_Launch_From_Admin_App: 355,
        QA_Related__QA_Launch_From_Scheduler: 356,
        QA_Related__QA_Launch_From_Completed: 357,
        Workflow_Parameters__DocumentTypeID_Supervisor: 359,
        Workflow_Parameters__Exception_Default_TIC_Choice: 360,
        UI_Data_Validation__Block_Duplicate_Workflows: 361,
        UI_Miscellaneous__Scroll_Into_View_Atalasoft: 362,
        UI_Miscellaneous__My_Report_Button_PBI_Link: 363,
        Alert_Automated_Related__Alert_Automated_Block_ID: 364,
        Alert_Automated_Related__Alert_Automation_Enable: 365,
        Workflow_Parameters__Contact_Center_Start_Queue_Text_Call_Taken: 366,
        YW_DMS_Related__Atalasoft_Enable_Doc_Display_Speed_Improvement: 367,
        RestApiService__WY_API_Key: 368,
        RestApiService__WY_SIG: 369,
        RestApiService__WY_Elementsservice: 370,
        Workflow_Parameters__Walk_In_Workflow_Map_All: 371,
        Workflow_Parameters__Walk_In_Workflow_Map_Indv: 372,
        WalkIn_Related__WalkIn_Worktime_Capture_Workflow_Auto_Start_Enable: 373,
        Workflow_Parameters__WalkIn_Start_Queue_Text_WalkIn_All_Recd: 374,
        Workflow_Parameters__WalkIn_Start_Queue_Text_WalkIn_Indv_Recd: 375,
        WalkIn_Related__Walkin_Case_Validation_Logic_Speed_Improvememt: 376,
        Scheduler__Scheduler_Batch_Size_Limit: 377,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Enable: 378,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_URL: 379,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Username: 380,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Password: 381,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Failure_Email_Address: 382,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_YTrac_URL: 383,
        Power_BI_Related__Power_BI_Completed_Export_Cutoff_Date: 384,
        Power_BI_Related__Power_BI_Export_Success_Email_List: 385,
        Power_BI_Related__Power_BI_Export_Failure_Email_List: 386,
        MultiState_Support__Citrix_Farm_Server_Name_Root: 387,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_SSN_Key: 388,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Case_Key: 389,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_SSN_Property: 390,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Case_Property: 391,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Document_Property: 392,
        UI_Miscellaneous__Use_DispatcherBeginInvoke_To_ScrollIntoVw_Atalsft: 393,
        Mainframe_Related__Case_Has_No_Orders_Message_Suppression: 394,
        Doc_Import_Processing__Doc_Import_Source_File: 399,
        Doc_Import_Processing__Doc_Import_Email_Subject: 400,
        Doc_Import_Processing__Email_List_For_Doc_Import_Success: 401,
        Doc_Import_Processing__Email_List_For_Doc_Import_Failure: 402,
        Doc_Import_Processing__Doc_Import_FTP_Profile: 403,
        Doc_Import_Processing__Doc_Import_Sweep_Path: 404,
        Doc_Import_Processing__Doc_Import_Archive_Path: 405,
        UI_Miscellaneous__Execution_Policy_For_Powershell_Script: 406,
        MS_BCS_IConnect_API_Connection_Related__MDHS_Import_SweepProcessID: 407,
        Case_Import_Processing__Case_Import_File: 408,
        Case_Import_Processing__Case_Import_Email_List_For_Success: 409,
        Case_Import_Processing__Case_Import_Email_List_For_Failure: 410,
        Case_Import_Processing__Case_Import_Format_File: 411,
        Case_Import_Processing__Case_Import_Archive_Path: 412,
        Case_Import_Processing__Case_Import_Source_File: 413,
        Case_Import_Processing__Case_Import_Email_Subject: 414,
        Case_Import_Processing__Case_Import_Decrypted_File: 415,
        Complaint_Escalation_Processing__Complaint_Escalation_Processing_Email_List_Success: 416,
        Complaint_Escalation_Processing__Complaint_Escalation_Processing_Email_List_Failure: 417,
        Legal_Display_Order__Legal_Sort_By: 418,
        Log_Purge_Related__Email_List_For_Log_Purge_Success: 419,
        Log_Purge_Related__Email_List_For_Log_Purge_Failure: 420,
        Log_Purge_Related__Purge_Age_For_AlertProcessingLog: 421,
        Log_Purge_Related__Purge_Age_For_DocTransferLog: 422,
        Log_Purge_Related__Purge_Age_For_ExceptionLog: 423,
        Log_Purge_Related__Purge_Age_For_TimedEventLog: 424,
        Log_Purge_Related__Purge_Age_For_CountEventLog: 425,
        Log_Purge_Related__Purge_Age_For_ScheduledJobLog: 426,
        Log_Purge_Related__Log_Purge_Email_Subject: 427,
        UI_Miscellaneous__Maximum_Results_On_Document_Search_Tab: 428,
        UI_Data_Validation__AutoEnd_Workflows_Second_Warning_Message: 429,
        UI_Miscellaneous__Case_Import_Display_Case_Data: 430,
        UI_Miscellaneous__SaveAndAnother_BackgroundWorkerActive: 431,
        UI_Miscellaneous__Enable_Work_Tab_Window_Docking: 432,
        UI_Miscellaneous__Enable_Add_Tab_Window_Docking: 433,
        UI_Miscellaneous__Enable_WalkIn_Tab_Window_Docking: 434,
        UI_Miscellaneous__Enable_Contact_Tab_Window_Docking: 435,
        DMS_Scanning__Atalasoft_Viewer_Resolution_Dpi: 436,
        UI_Miscellaneous__Combobox_Type: 437,
        YW_DMS_Related__Manage_Keywords_Default_Doc_Source_ID: 438,
        YW_DMS_Related__Atalasoft_Viewer_Pop_Out_Capability: 439,
        Follow_Ups_Related_Category__Follow_Ups_Action_And_TICChoice_Dropdown: 440,
        Mail_Controls__Doc_Distro_Previous_Case_Checkbox: 441,
        YW_DMS_Related__Doc_Viewer_Default_Zoom_For_Popout_Mode: 442,
        YW_DMS_Related__Doc_Viewer_Default_Zoom_For_InModule_Mode: 443,
        UI_Miscellaneous__Printer_Dialog_Settings: 444,
        UI_Miscellaneous__Right_Side_Slow_Case_Entry_Speed_Improve: 445,
        YW_DMS_Related__Doc_Viewer_Type: 446,
        UI_Miscellaneous__Knowledge_Base_Combobox_TYPE: 447,
        SignalRService__WalkIn_Notification_Lifespan: 448,
        Document_Related__Export_Doc_Limit: 449,
        SignalRService__SignalR_Service_For_QA_Notification_Enable: 450,
        SignalRService__SignalR_Service_For_WalkIn_Notification_Enable: 451,
        Document_Related__Export_Doc_Email_Address_Validation: 452,
        Document_Related__Export_Docs_Sender_Email: 453,
        Document_Related__Export_Docs_Expire_After_Days: 454,
        Document_Related__Export_Docs_Max_Downloads: 455,
        Document_Related__Export_Docs_Delete_After_Max_Downloads: 456,
        Document_Related__Export_Docs_Password: 457,
        Document_Related__Export_Docs_Generate_Random_Password: 458,
        Document_Related__Export_Docs_Secure: 459,
        Document_Related__JScape_Scheme: 460,
        Document_Related__JScape_CSRF_Token_URI: 461,
        Document_Related__JScape_Login_URI: 462,
        Document_Related__JScape_Logout_URI: 463,
        Document_Related__JScape_Email_File_URI: 464,
        Document_Related__JScape_Domain: 465,
        Document_Related__JScape_Username: 466,
        Document_Related__JScape_Password: 467,
        Document_Related__JScape_Host: 468,
        Document_Related__JScape_Port: 469,
        Document_Related__JScape_Reply_To: 470,
        Document_Related__JScape_CC_Recipients: 471,
        Document_Related__JScape_BCC_Recipients: 472,
        Document_Related__JScape_Exclude_Password_From_Email : 473,
        Document_Related__JScape_Server_Name: 474,
        Document_Related__JScape_Server_Port: 475,
        Document_Related__JScape_Multipart_Email: 476,
        Document_Related__JScape_Text_Template: 477,
        Document_Related__JScape_HTML_Template: 478,
        Document_Related__JScape_File_Path: 479,
        DMS_Scanning__Scheduler_Sweep_Minutes_Requirement: 480,
        UI_Data_Validation__Max_Number_Of_Attempts_To_GetNextTask: 481,
        UI_Data_Validation__Time_Delay_MilliSeconds_Before_Checking_Lock: 482,
        Document_Related__JScape_CSRF_Token_Name: 483,
        Document_Related__JScape_X_Requested_With: 484,
        Document_Related__JScape_XML_Http_Request: 485,
        Database_Performance_Related__GNT_Enable_Logging_DB: 487,
        Database_Performance_Related__GNT_Retry_Loop_Count_DB: 488,
        Database_Performance_Related__GNT_Retry_Delay_DB: 489,
        SQL_HA_Platform_Related__SSRS_SQL_Server: 490,
        YW_DMS_Related__Use_PagebyPage_PdfDocument_For_PDF_Doc_Split: 491,
        SQL_HA_Platform_Related__Failover_Job_Success_Email_List: 492,
        SQL_HA_Platform_Related__Failover_Job_Failure_Email_List: 493,
        Alert_Import_Processing__Alert_File_Open_Delay: 494,
        SQL_HA_Platform_Related__DB_Object_Sync_Job_Success_Email_List: 495,
        SQL_HA_Platform_Related__DB_Object_Sync_Job_Failure_Email_List: 496,
        SQL_HA_Platform_Related__DB_Object_Check_Job_Success_Email_List: 497,
        SQL_HA_Platform_Related__DB_Object_Check_Job_Failure_Email_List: 498,
        SQL_HA_Platform_Related__Bulk_File_Import_Job_Success_Email_List: 499,
        SQL_HA_Platform_Related__Bulk_File_Import_Job_Failure_Email_List: 500,
        UI_Miscellaneous__Rows_Per_Page_Queue_Tab: 501,
        UI_Miscellaneous__Max_Queue_Tab_Page_Selector: 502,
        UI_Miscellaneous__Queue_Tab_Three_Dots_Page_Change_Amount: 503,
        Log_Purge_Related__Processed_Folder_Purge_Age: 504,
        Log_Purge_Related__Processed_Folder_Purge_Enable: 505,
        UI_Miscellaneous__WorkFlowMessageForegroundColor_Multiple_Workflows: 506,
        UI_Miscellaneous__WorkFlowMessageForegroundColor_No_Case_Number: 507,
        UI_Miscellaneous__WorkFlowMessageMargin_Multiple_Workflows: 508,
        UI_Miscellaneous__WorkFlowMessageMargin_No_Case_Number: 509,
        Legal_Display_Order__Judge_And_Court: 510,
        DMS_Scanning__Scheduler_PDF_EOF_Tag_Index_Position: 511,
        Document_Related__JScape_Server_CSRF_Token_URI: 512,
        Document_Related__JScape_Server_Login_URI: 513,
        Document_Related__JScape_Server_Logout_URI: 514,
        Document_Related__JScape_Server_Username: 515,
        Document_Related__JScape_Server_Password: 516,
        Document_Related__JScape_Server_Host: 517,
        Document_Related__JScape_Server_TLD_URI: 518,
        Doc_Import_Processing__Doc_Import_File: 519,
        Doc_Import_Processing__Doc_Import_Format_File: 520,
        UI_Miscellaneous__NCP_Name_Display_Workflow_View: 521,
        UI_Miscellaneous__NCP_Name_Display_Legal_View: 522,
        UI_Miscellaneous__Days_To_Next_Followup: 523,
        UI_Miscellaneous__Terminated_Workflow: 524,
        NICE_Integration_Related__NICE_Grant_Type: 525,
        NICE_Integration_Related__NICE_Client_ID : 526,
        NICE_Integration_Related__NICE_Client_Secret: 527,
        NICE_Integration_Related__NICE_Username: 528,
        NICE_Integration_Related__NICE_Password: 529,
        NICE_Integration_Related__NICE_Token_Path: 530,
        NICE_Integration_Related__NICE_Auto_Call_Reject_Status: 531,
        NICE_Integration_Related__NICE_ACD_Queue_List_Of_Name_Starts_With: 532,
        NICE_Integration_Related__NICE_Host: 533,
        NICE_Integration_Related__NICE_Content_Type: 534,
        NICE_Integration_Related__NICE_API_Host: 536,
        NICE_Integration_Related__NICE_API_URL: 537,
        NICE_Integration_Related__NICE_Agent_API: 538,
        Misc_Job_Related__Doc_Type_Mismatch_Remediation_Success_Email_List: 540,
        Misc_Job_Related__Doc_Type_Mismatch_Remediation_Failure_Email_List: 541,
        Misc_Job_Related__Doc_Type_Mismatch_Remediation_Email_Subject: 542,
        NICE_Integration_Related__NICE_Agent_Sessions_Join_API: 544,
        NICE_Integration_Related__NICE_Agent_Sessions_Join_Parameters: 545,
        NICE_Integration_Related__NICE_Agent_Sessions: 546,
        NICE_Integration_Related__NICE_Get_Next_Event_API: 547,
        NICE_Integration_Related__NICE_Get_Next_Event_Parameters: 548,
        NICE_Integration_Related__NICE_Get_Next_Event_Parameter_Time_In_Seconds: 549,
        NICE_Integration_Related__NICE_Skill_API: 550,
        NICE_Integration_Related__NICE_Skill_API_Parameters: 551,
        NICE_Integration_Related__NICE_API_Version: 552,
        NICE_Integration_Related__NICE_Interactions: 553,
        NICE_Integration_Related__NICE_Accept_Call: 554,
        NICE_Integration_Related__NICE_Reject_Call: 555,
        NICE_Integration_Related__NICE_Available_Agent_Status: 556,
        NICE_Integration_Related__NICE_Unavailable_Agent_Status_With_Reason: 557,
        NICE_Integration_Related__NICE_Call_Starting_Event: 558,
        NICE_Integration_Related__NICE_Phone_System_ID: 559,
        NICE_Integration_Related__NICE_Pickup_Button_Visible: 560,
        UI_Miscellaneous__Switch_For_Enablingdisabling_Garbage_Collection: 561,
        Scheduler__PDF_Page_Width_In_Points: 563,
        Scheduler__PDF_Page_Height_In_Points: 564,
        NICE_Integration_Related__NICE_Default_Delay_Polling_Time: 565,
        NICE_Integration_Related__NICE_Accept_Reject_Delay_Polling_Time: 566,
        Code_Switching__Use_New_Code_For_CC_CaseNumber_Setter: 567,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_MaxDegreeOfParallelism: 568,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Cancel_Token: 569,
        MS_BCS_IConnect_API_Connection_Related__MSiConnect_Service_SleepTime: 570,
        NICE_Integration_Related__NICE_Maximum_Connection_Retries: 571,
        RestApiService__VA_Rest_API_Token_URL: 572,
        RestApiService__VA_Token_ApiVersion: 573,
        RestApiService__VA_Rest_API_URL: 574,
        RestApiService__VA_Rest_API_ApiVersion: 575,
        UI_Miscellaneous__Contact_Center_WalkIn_Combobox_Type: 576,
        UI_Miscellaneous__Last_4_SSN_Show_Enable: 577,
        UI_Miscellaneous__Manage_Transaction_No_Show: 578,
        RestApiService__State_Case_System_Username: 579,
        RestApiService__State_Case_System_Pw: 580,
        UI_Data_Validation__Company_FEIN_Regex_Pattern: 581,
        UI_Miscellaneous__Manage_Company_FEIN_And_No_FEIN_Show: 582,
        UI_Data_Validation__Last_4_SSN_Regex_Pattern: 583,
        UI_Miscellaneous__Manage_Voice_Signature_Show: 584,
        Install__AutoUpdate_Enable: 585,
        UI_Miscellaneous__FVI_Possibility_Range: 586,
        UI_Data_Validation__Email_Regex_Pattern: 587,
        UI_Data_Validation__First_Name_Regex_Pattern: 588,
        UI_Data_Validation__Last_Name_Regex_Pattern: 589,
        UI_Data_Validation__City_Regex_Pattern: 590,
        UI_Data_Validation__Nine_Digit_Zip_Code_Regex_Pattern: 591,
        UI_Data_Validation__Five_Digit_Zip_Code_Regex_Pattern: 592,
        UI_Data_Validation__Phone_Number_Regex_Pattern: 593,
        RestApiService__VA_Case_Rest_API_URL: 594,
        UI_Miscellaneous__Auto_Send_Contact_Center_Action_Contact_Info: 595,
        UI_Data_Validation__US_Phone_Fax_Number_Max_Length: 596,
        UI_Data_Validation__International_Phone_Fax_Number_Max_Length: 597,
        UI_Miscellaneous__CC_Narrative_Copy_To_Clipboard_Contact: 598,
        UI_Miscellaneous__WF_Narrative_Copy_To_Clipboard_Add_Tab: 599,
        UI_Miscellaneous__WF_Narrative_Copy_To_Clipboard_Work_Tab: 600,
        UI_Miscellaneous__WF_Narrative_Copy_To_Clipboard_Walk_In: 601,
        UI_Miscellaneous__DD_Narrative_Copy_To_Clipboard_Index: 602,
        UI_Miscellaneous__DD_Narrative_Copy_To_Clipboard_Manage_Keywords: 603,
        Scheduler__Scheduler_Bad_Filename_Characters: 604,
        Scheduler__Scheduler_File_Rename_Sleep_Timer: 605,
        UI_Miscellaneous__CASE_Type_NIVD_Show: 606,
        NICE_Integration_Related__NICE_Contacts_Custom_Data_API: 607,
        NICE_Integration_Related__NICE_Custom_Data_Call: 608,
        NICE_Integration_Related__NICE_Call_Contacts_Custom_Data: 609,
        UI_Miscellaneous__US_Country_Name: 610,
        Install__AVD_Host_Name_Root: 611,
        UI_Miscellaneous__Participant_Error: 612,
        UI_Miscellaneous__CC_Show_Skill: 613,
        Log_Purge_Related__Purge_Age_For_IVRCustomData: 614,
        UI_Behavior__Case_Search_YTracCase_Insert: 615,
        Document_Related__Doc_Viewer_License: 616,
        Custom_SpellCheck_Related__Custom_SpellCheck_Enable: 617,
        Custom_SpellCheck_Related__Custom_SpellCheck_Dictionary_Name: 618,
        Custom_SpellCheck_Related__Custom_SpellCheck_Dictionary_Path: 619,
        UI_Miscellaneous__CS_ContactChannel: 621,
        UI_Miscellaneous__CS_ContactCompany_FEIN: 622,
        UI_Miscellaneous__CS_ContactCategory: 623,
        UI_Miscellaneous__CS_ContactSubCategory: 624,
        UI_Miscellaneous__Include_UNKN_ContactRoles_For_With_Case: 625,
        Custom_SpellCheck_Related__Custom_SpellCheck_AA_Dictionary_Path: 626,
        Contact_Center_Email_Related__Email_DM_CallBack_Request_Email_To: 627,
        Contact_Center_Email_Related__Email_DM_CallBack_Request_CC: 628,
        Contact_Center_Email_Related__Email_DM_CallBack_Request_Subject: 629,
        Contact_Center_Email_Related__Email_Second_Issue_DM_CallBack_Request_Email_To: 630,
        Contact_Center_Email_Related__Email_Second_Issue_DM_CallBack_Request_CC: 631,
        Contact_Center_Email_Related__Email_Second_Issue_DM_CallBack_Request_Subject: 632,
        Contact_Center_Email_Related__Email_Missing_Application_Email_To: 633,
        Contact_Center_Email_Related__Email_Missing_Application_CC: 634,
        Contact_Center_Email_Related__Email_Missing_Application_Subject: 635,
        UI_Miscellaneous__Success_Notification_Timer: 636,
        UI_Miscellaneous__Index_Softlock_Timer: 637,
        Scheduler__Scheduler_Monitor_Log_Age_Threshold: 638,
        Scheduler__Scheduler_Monitor_Email_Subject: 639,
        Scheduler__Scheduler_Monitor_Success_Email_List: 640,
        Scheduler__Scheduler_Monitor_Failure_Email_List: 641,
        Reporting_Related__G4_SSO_SQL_Server_Database_Schema: 642,
        Scheduler__Job_History_Purge_Email_Subject: 644,
        Scheduler__Job_History_Purge_Success_Email_List: 645,
        Scheduler__Job_History_Purge_Failure_Email_List: 646,
        UI_Miscellaneous__Inactivity_Notification_Minutes: 647,
        UI_Miscellaneous__Error_Notification_Timer: 648,
        Contact_Center_Email_Related__Email_NextGen_FIRST_Request_Email_To: 649,
        Contact_Center_Email_Related__Email_NextGen_FIRST_Request_CC: 650,
        Contact_Center_Email_Related__Email_NextGen_FIRST_Request_Subject: 651,
        Code_Switching__Check_Mainframe_Connectivity_On_Search: 652,
    },
    NoteTemplateParmType: {
        Current_User: 1,
        Current_Date: 2,
        UI_Element: 3,
        UI_Element_Multiple_Parent: 4,
        UI_Element_Multiple_Child: 5,
        MultipleItemGroupStarter: 6,
        Current_Time: 8,
        Document_Type: 9,
        Document_Source: 10,
        Property_Date_Only: 11,
        TIC_Choice: 12,
    },
    NoteTemplate: {
        Drive_Narrative_From_WorkflowMap: -1,
        Place_Holder_DO_NOT_DELETE: 0,
        BLANK_Narrative: 1,
        Workflow_MS_Supervisor_Closure: 2,
        Mail_Mainframe_Narrative: 3,
        Establishment_Mainframe_Narrative: 7,
        Establishment_Mainframe_Narrative_Start_Workflow: 9,
        Customer_Service_Mainframe_Narrative: 10,
        Legal_Action_Created: 14,
        QA_Of_Case_Narrative: 18,
        Customer_Service_Refer_Message: 19,
        Customer_Service_Other_Action: 20,
        Customer_Service_Mail_Doc: 21,
        Customer_Complaint_Final_Resolution_Narrative: 22,
        Modification_Of_Case_Narrative: 24,
        Establishment_Mainframe_Narrative_MS_2: 25,
        WalkIn_Resolved: 26,
        ReferSup_Interview: 27,
        ReferCW_Interview: 28,
        When_Hearing_Result_Selected_OR_Saved: 29,
        When_Hearing_DateTime_Selected: 30,
        Intake_Workflow: 31,
        Arrears_Workflow: 32,
        NCP_Assessment_Record_Saved: 33,
        Forms_Subtab_Narrative: 34,
        Specialized_Worklist_SWL1_Action_Narrative: 35,
        Specialized_Worklist_SWL2_Action_Narrative: 36,
        Specialized_Worklist_SWL3_Action_Narrative: 37,
        Specialized_Worklist_SWL4_Action_Narrative: 38,
        Specialized_Worklist_SWL1_Sent_To_Supe_Narrative: 39,
        Specialized_Worklist_SWL2_Sent_To_Supe_Narrative: 40,
        Specialized_Worklist_SWL3_Sent_To_Supe_Narrative: 41,
        Specialized_Worklist_SWL4_Sent_To_Supe_Narrative: 42,
        YStrat_Worklist1_Action_Narrative: 43,
        YStrat_Worklist2_Action_Narrative: 44,
        YStrat_Worklist3_Action_Narrative: 45,
        YStrat_Worklist4_Action_Narrative: 46,
        YStrat_Worklist1_Sent_To_Supe_Narrative: 47,
        YStrat_Worklist2_Sent_To_Supe_Narrative: 48,
        YStrat_Worklist3_Sent_To_Supe_Narrative: 49,
        YStrat_Worklist4_Sent_To_Supe_Narrative: 50,
        Doc_Distro_Mainframe_Narrative: 51,
        QA_Workflow_Nonactionspecific_Narrative: 122,
        SWLA_Worked_Action_Narrative: 123,
        SWLB_Worked_Action_Narrative: 124,
        SWLC_Worked_Action_Narrative: 125,
        SWLD_Worked_Action_Narrative: 126,
        SWLImport_Excep_Worked_Action_Narrative: 127,
        SWL_L2_Worked_Action_Narrative: 128,
        SWL_L3_Worked_Action_Narrative: 129,
        SWLA_Sent_To_L2_Action_Narrative: 130,
        SWLB_Sent_To_L2_Action_Narrative: 131,
        SWLC_Sent_To_L2_Action_Narrative: 132,
        SWLD_Sent_To_L2_Action_Narrative: 133,
        SWLImport_Excep_Sent_To_L2_Action_Narrative: 134,
        Special_Worklist_Sent_To_L3_Action_Narrative: 135,
        YStratA_Worked_Action_Narrative: 136,
        YStratB_Worked_Action_Narrative: 137,
        YStratC_Worked_Action_Narrative: 138,
        YStratD_Worked_Action_Narrative: 139,
        YStratImport_Excep_Worked_Action_Narrative: 140,
        YStrat_L2_Worked_Action_Narrative: 141,
        YStrat_L3_Worked_Action_Narrative: 142,
        YStratA_Sent_To_L2_Action_Narrative: 143,
        YStratB_Sent_To_L2_Action_Narrative: 144,
        YStratC_Sent_To_L2_Action_Narrative: 145,
        YStratD_Sent_To_L2_Action_Narrative: 146,
        YStratImport_Excep_Sent_To_L2_Action_Narrative: 147,
        YStrat_Sent_To_L3_Action_Narrative: 148,
        Document_Terminate_Workflow: 149,
        Doc_Distro_Mainframe_Narrative_AutoEnd: 150,
        SWL_AZ_Work: 151,
        SWL_AZGeneric_L2_Escalation: 152,
        SWL_L3_Escalation: 153,
        Establishment_Mainframe_Narrative_FollowUp: 154,
        Mainframe_Narrative_Start_Workflow_FollowUp: 155,
        Doc_Type_Terminated: 171,
        Doc_Type_Work_In_Queue: 172,
        WalkIn_Other_Action: 173,
        Legal_Action: 174,
        Mainframe_Narrative_Start_FollowUp_Workflow: 175,
        Mainframe_Narrative_Start_Complaints_Workflow: 176,
        LegalContempt_Action: 177,
        LegalMod_Action: 178,
        Legal_Other_Action: 179,
        JD: 180,
        end: 218,
        SWL_Queues_To_Remove_Narrative_Template: 219,
        Alerts_To_Remove_Narrative_Template: 220,
        Documents_To_Remove_Narrative_Template: 221,
        Intake_To_Remove_Narrative_Template: 222,
        EstLocate_To_Remove_Narrative_Template: 223,
        EstCase_Closure_To_Remove_Narrative_Template: 224,
        EstRev_And_Prep_To_Remove_Narrative_Template: 225,
        Follow_Ups_To_Remove_Narrative_Template: 226,
        Complaints_To_Remove_Narrative_Template: 227,
        New_Order_Entry_To_Remove_Narrative_Template: 228,
        EstIntergov_To_Remove_Narrative_Template: 229,
        Customer_Service_With_Case_Short_Circuit: 230,
        WalkIn_With_Case_Short_Circuit: 231,
    },
    IntegrationCategoryType: {
        Placeholder: 0,
        DMS: 1,
        Host: 2,
        Phone: 3,
    },
	IntegrationType: {
		Placeholder: 0,
		Mainframe_Host: 1,
		Phone_System_I3Genesys: 2,
		OnBase: 3,
		Atalasoft: 4,
		REST_API_Service_WY: 6,
		Soap_Service: 7,
		Phone_System_NICE: 8,
		REST_API_Service_VA: 9,
		REST_API_Service_KS: 10,
	},
    Feature: {
        Separate_Input_Channel_Choice_Dropdown: 144,
    },
    ActionType : {
        Base_Feature: 0,
        No_Display: 2,
        Display: 3,
    },
    Module: {
        Workflow: 1,
    }
};